import React, {useEffect, useState} from "react"
import PropTypes from "prop-types"
import PriceService from "src/services/price-service"
import {localeBRDataGridText} from "src/utils/data-grid-local-text"
import {columnsPrecoVariacaoDiaria} from "./tabela-preco-variacao-constants"
import DataGridTable from "../../../../components/Table/data-grid-table"


const TabelaPrecoVariacao = ({date, setLoading, setExportFileCsv}) => {
    const priceService = new PriceService()
    const [priceList, setPriceList] = useState([])

    useEffect(() => {
        setExportFileCsv(() => () => priceService.exportDataVariationToCsv(date))
        loadPrices(date)
    }, [])

    const loadPrices = () => {
        setLoading(true)
        priceService.loadTablePriceVariantion(date, date)
            .then((response) => {
                setLoading(false)
                const {body} = response
                const {data} = body
                const rows = data.map((obj, index) => ({...obj, id: index}))
                setPriceList(rows)
            })
            .finally(() => {
                setLoading(false)
            })
    }

    return (
        <>
            <DataGridTable
                rows={priceList}
                columns={columnsPrecoVariacaoDiaria()}
                pageSize={25}
                disableRowSelectionOnClick
                sortingOrder={['asc', 'desc']}
                localeText={localeBRDataGridText}
            />
        </>
    )
}

// Adicionando prop-types para validação
TabelaPrecoVariacao.propTypes = {
    date: PropTypes.string,
    setLoading: PropTypes.func,
    loading: PropTypes.bool,
    setExportFileCsv: PropTypes.func,
}
export default TabelaPrecoVariacao
